import * as React from 'react';
import { Icon } from '@hotjar/hotsauce';
import type { IconName } from '@hotjar/hotsauce';
import { StyledTile, StyledTileLeft, StyledTileIcon, StyledTileTitle, StyledValue } from './styles';

export const Tile = ({
  title,
  icon,
  color,
  value,
  onClick,
}: {
  title: string;
  icon: IconName;
  color: string;
  value: React.ReactNode | string;
  onClick?: () => void;
}): JSX.Element => (
  <StyledTile clickable={typeof onClick === 'function'} onClick={onClick}>
    <StyledTileLeft>
      <StyledTileIcon color={color}>
        <Icon size="m" icon={icon} />
      </StyledTileIcon>

      <StyledTileTitle>{title}</StyledTileTitle>
    </StyledTileLeft>

    {typeof value === 'object' ? value : <StyledValue>{value}</StyledValue>}
  </StyledTile>
);
